jQuery('.popup').on('click', function(e)  {
    if( jQuery( e.target ).is( ".popup" ) ) {
        jQuery('.popup').fadeOut(350);
    }
});

jQuery(window).on('keyup', function(e) {
    if (27 === e.keyCode) {
        jQuery('.popup').fadeOut(350);
    }
});

jQuery('[data-popup-open]').on('click', function(e)  {
    jQuery('.popup').fadeOut(350);	    	
    var targeted_popup_class = jQuery(this).attr('data-popup-open');
    jQuery('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);
    e.preventDefault();
    jQuery(window).trigger('resize');
});

jQuery('[data-popup-open]').on('keypress', function(e)  {
    if (e.which === 13 || e.which === 32) {
        jQuery('.popup').fadeOut(350);	    	
        var targeted_popup_class = jQuery(this).attr('data-popup-open');
        jQuery('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);
        e.preventDefault();
        jQuery(window).trigger('resize');
    }
});

jQuery('[data-popup-close]').on('click', function(e)  {
    if( e.target !== this ) {
        e.preventDefault();
        return;
    }

    var targeted_popup_class = jQuery(this).attr('data-popup-close');
    jQuery('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);     
    
});

jQuery(document).ready(function(e) {
    var suspend = jQuery.cookie('subscribe_modal');

    if(suspend != 'true') {
        jQuery('[data-popup="popup-subscribe"]').fadeIn(350);
        jQuery.cookie('subscribe_modal', 'true', { domain: '.myshopify.com', path: '/', expires: 90 });
        jQuery.cookie('subscribe_modal', 'true', { domain: '.octobersveryown.com', path: '/', expires: 90 });
    }

    jQuery('#subscribe2').on('click', function(e) {
        jQuery.cookie('subscribe_modal', 'true', { domain: '.myshopify.com', path: '/', expires: 90 });
        jQuery.cookie('subscribe_modal', 'true', { domain: '.octobersveryown.com', path: '/', expires: 90 });
        jQuery('[data-popup="popup-subscribe"]').fadeOut(350);
    });
});